export default __webpack_public_path__ + "static/media/logo.28cd93c5.svg";